<template>
    <div id="footer">
        <div class="footer-top">
            <div class="container">
                <div class="wrap-footer">
                    <div class="logo-brand-footer">
                        <a href="https://astra-honda.com" class="logo honda"><img :src="cdn_url+'/assets/images/logo/honda.svg'" alt="Honda Logo"></a>
                    </div>
                    <div class="row-grid">
                        <div class="col-grid-30">
                            <div class="wrap-col-footer">
                                <nav id="footer-menu">
                                    <!-- <div id="wrapper">
                                        <accordion :items="items"></accordion>
                                    </div> -->
                                    <div id="accordion">
                                        <ul class="list-footerMenu">
                                            <li class="menus-item" v-for="item in items" @click="openItem(item)" :key="item.id">
                                            <!-- <div class="arrow_box" :class="{'arrow_box--open' : item.isopen}"></div> -->
                                            <span class="title">{{item.title}}</span>
                                            <ul class="item-menu" v-show="item.isopen" :class="setClass(item)">
                                                <li v-for="listMenu in item.submenus.submenu" :key="listMenu.id">
                                                    <a @click="gtmTrackerMenu(listMenu)" :href="listMenu.url" :target="listMenu.newTab ? '_blank' : '_self'">{{listMenu.name}}</a>
                                                </li>
                                            </ul>
                                            </li>
                                        </ul>
                                    </div>
                                </nav>
                            </div>
                        </div>
                        <div class="col-grid-30">
                            <newsletter></newsletter>
                        </div>
                        <div class="col-grid-30">
                            <div class="wrap-footAddress">
                                <div class="foot-img-logo">
                                    <img :src="cdn_url+'/assets/images/logo/hondacare.svg'" alt="Customer Care">
                                </div>
                                <div class="foot-address">
                                    <p>
                                        PT. Astra Honda Motor <br>
                                        Jl. Laksda Yos Sudarso - Sunter 1 <br>
                                        Jakarta 14350, Indonesia <br>
                                        Tel. 0811-9-500-989
                                    </p>
                                </div>
                                <div class="foot-img-logo">
                                    <a href="https://sustainability.honda.asia/">
                                        <img :src="cdn_url+'/assets/images/logo/blue-skies.svg'" alt="Blue Skies">
                                    </a>
                                </div>
                                <div class="foot-img-logo">
                                    <a href="/komik">
                                        <img :src="cdn_url+'/assets/images/logo/soichiro-honda.svg'" alt="Blue Skies">
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-bottom">
            <div class="container">
                <div class="text-center">
                    <p><a @click="trackerPrivacyPage('Footer Menu Click', 'Kebijakan Privasi', 'https://www.astra-honda.com/page/kebijakan-privasi')" href="https://www.astra-honda.com/page/kebijakan-privasi">Kebijakan Privasi</a> | <a @click="trackerPrivacyPage('Footer Menu Click', 'Legal Cookie', 'https://www.astra-honda.com/page/cookie')" href="https://www.astra-honda.com/page/cookie">Legal Cookie</a></p>
                    <p>© Copyright 2020, PT. Astra Honda Motor. All Rights Reserved.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Newsletter from '../../widget/Newsletter.vue'
    export default {
        components: {
            'newsletter': Newsletter,
        },
        created(){
            //this.old_url ='https://www.astra-honda.com/'
            //this.community_url = community_url
            this.base_url = base_url;
        },
        data: function() {
            return{
                // submenu:[],
                // items:[],
                //old_url:'',
                //community_url:'',
                cdn_url: cdn_url,
                base_url:'',
                items: [{
                    id: 1,
                    title: 'Corporate',
                    submenus: {
                        submenu: [
                            {id: 1, name: 'Profile', url: '/corporate', type: 'abc', newTab: false},
                            {id: 2, name: 'Visi Misi', url: '/corporate', type: 'def', newTab: false},
                            {id: 3, name: 'ONE HEART', url: '/corporate', type: 'def', newTab: false},
                            {id: 4, name: 'Sejarah', url: '/corporate', type: 'ghi', newTab: false},
                            {id: 5, name: 'Main Dealer', url: '/corporate', type: 'ghi', newTab: false},
                            {id: 6, name: 'Sustainability', url: '/corporate-social-responsibility', type: 'ghi', newTab: false},
                            {id: 7, name: 'Penghargaan', url: '/corporate', type: 'ghi', newTab: false},
                            {id: 8, name: 'Karir', url: '/career', type: 'ghi', newTab: false},
                            {id: 9, name: 'Product Update', url: '/product-update', type: 'ghi', newTab: false},
                        ]
                    },
                    isopen: false
                },{
                    id: 2,
                    title: 'Global Honda',
                    submenus: {
                        submenu: [
                            {id: 1, name: 'Global Honda', url: 'https://global.honda/en/?utm_source=ahj&utm_medium=web&utm_campaign=footer', type: 'abc', newTab: true},
                            {id: 2, name: 'Global Brand Slogan', url: 'https://global.honda/en/brand/?utm_source=ahj&utm_medium=web&utm_campaign=footer', type: 'def', newTab: true},
                            {id: 3, name: 'Honda History', url: 'https://global.honda/en/about/history.html?utm_source=ahj&utm_medium=web&utm_campaign=footer', type: 'def', newTab: true},
                            {id: 4, name: 'Honda Philosophy', url: 'https://global.honda/en/about/philosophy/?utm_source=ahj&utm_medium=web&utm_campaign=footer', type: 'ghi', newTab: true},
                        ]
                    },
                    isopen: false
                },{
                    id:3,
                    title: 'Products',
                    submenus: {
                        submenu: [
                            {id: 1, name: 'Honda Matic', url: '/product?category=matic', type: 'abc', newTab: false},
                            {id: 2, name: 'Honda Bebek', url: '/product?category=cub', type: 'def', newTab: false},
                            {id: 3, name: 'Honda Sport', url: '/product?category=sport', type: 'def', newTab: false},
                            {id: 4, name: 'Honda BigBike', url: '/hondabigbike', type: 'def', newTab: false},
                            {id: 5, name: 'Honda Technology', url: '/hondasmarttechnology/', type: 'def', newTab: false},
                            {id: 6, name: 'Price List', url: '/product/price-list', type: 'def', newTab: false},
                        ]
                    },
                    isopen: false
                },{
                    id:4,
                    title: 'After Sales',
                    submenus: {
                        submenu: [
                            {id: 1, name: 'Service', url: '/after-sales/service', type: 'abc', newTab: false},
                            {id: 2, name: 'Honda Genuine Parts', url: '/after-sales/honda-genuine-parts', type: 'abc', newTab: false},
                            {id: 3, name: 'Honda Tire', url: '/after-sales/honda-tire', type: 'abc', newTab: false},
                            {id: 4, name: 'AHM Oil', url: '/after-sales/ahm-oil', type: 'abc', newTab: false},
                            {id: 5, name: 'Honda Accessories', url: '/after-sales/honda-accessories', type: 'abc', newTab: false},
                            {id: 6, name: 'Honda Apparel', url: '/after-sales/honda-apparel', type: 'abc', newTab: false}
                        ]
                    },
                    isopen: false
                },{
                    id:5,
                    title: 'Highlight',
                    submenus: {
                        submenu: [
                            {id: 1, name: 'Honda BigBike', url: '/hondabigbike', type: 'abc', newTab: false},
                            {id: 2, name: 'Safety Riding', url: '/safety-riding', type: 'def', newTab: false},
                            {id: 3, name: 'Racing', url: '/racing', type: 'def', newTab: false},
                            {id: 4, name: 'Community', url: '/community', type: 'def', newTab: false},
                            {id: 5, name: 'Promo & Events', url: '/promo', type: 'def', newTab: false},
                            {id: 6, name: 'Artikel', url: '/article', type: 'def', newTab: false},
                        ]
                    },
                    isopen: false
                },{
                    id:6,
                    title: 'Press Release',
                    submenus: {
                        submenu: [
                            {id: 1, name: 'Press Release', url: '/news-events/press-release', type: 'abc', newTab: false},
                        ]
                    },
                    isopen: false
                },{
                    id:7,
                    title: 'Contact Us',
                    submenus: {
                        submenu: [
                            {id: 1, name: 'Help Center', url: 'https://www.astra-honda.com/helpcenter', type: 'abc', newTab: false},
                        ]
                    },
                    isopen: false
                }]
            }
        },
        methods: {
            // GTM Tracker
            gtmTrackerMenu(event) {
                var data = {
                    'event': 'footerMenuClick',
                    'eventDetail.category': 'Custom Event',
                    'eventDetail.action':'Footer Menu Click',
                    'eventDetail.label': event.name,
                    'pageURL': window.location.href
                }
                dataLayer.push(data);
            },
            //End GTM Tracker
            openItem: function(item){
                item.isopen = !  item.isopen;
            },
            setClass: function(item){
                if (item.isopen == true ) {
                return 'open'
                }
                return 'close'
            },
            trackerPrivacyPage(action, label, destinationPageUrl) {
                const dataTracker = {
                    'event': 'footerMenuClick',
                    'eventDetail.category': 'Custom Event',
                    'eventDetail.action': action,
                    'eventDetail.label': label,
                    'destinationPageUrl': destinationPageUrl,
                }
                dataLayer.push(dataTracker);
            }
            // enter: function(el, done){
            //     Velocity(el, 'slideDown', {duration: 400,
            //                             easing: "easeInBack"},
            //                             {complete: done})
            // },
            // leave: function(el, done){
            //     Velocity(el, 'slideUp', {duration: 400,
            //                             easing: "easeInBack"},
            //                             {complete: done})
            // },
        }

    }
</script>>

<style scoped>
    .footer-top{
        background-color: #282828;
        padding-top: 4em;
        padding-bottom: 2em;
        position: relative;
    }
    #footer{
        margin-top: 5em;
    }
    .footer-bottom{
        background-color: #353535;
        padding: 15px 0;
    }
    .footer-bottom a{
        color:#fff;
        font-size: 12px;
        padding: 0 20px;
    }
    .footer-bottom p{
        color: #fff;
        opacity: .7;
        font-weight: 300;
    }
    .footer-bottom p:first-child{
        margin-top: 0;
    }
    .footer-bottom p:last-child{
        margin-bottom: 0;
    }
    .logo-brand-footer{
        margin-bottom: 2em;
    }
    .list-footerMenu{
        color: #fff;
        padding-left: 0;
        margin: 0 0 20px 0;
    }
    .list-footerMenu .menus-item{
        padding: 15px 0;
        border-bottom: solid 1px rgba(255, 255, 255, .1);
        cursor: pointer;
        font-size: 15px;
        position: relative;
    }
    .title{
        position: relative;
        display: block;
        width: 100%;
    }
    .list-footerMenu .title:before{
        position: absolute;
        content: '';
        top: 50%;
        right: 0;
        transform: translate(0, -50%);
        background-image: url('/assets/images/icons/back.svg');
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100%;
        width: 12px;
        height: 12px;
    }
    .list-footerMenu .menus-item:first-child{
        padding-top: 0;
    }
    .item-menu{
        margin-top: 20px;
        margin-bottom: 10px;
        padding-left: 20px;
    }
    .list-footerMenu li .item{
        padding: 20px 0 10px 20px;
        color: #fff;
        display: block;
    }
    @-webkit-keyframes open {
        from {
            -webkit-transform: translate3d(0, -20%, 0);
            transform: translate3d(0, -20%, 0);
            visibility: visible;
            opacity: 0;
        }

        to {
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
            opacity: 1;
        }
    }

    @keyframes open {
        from {
            -webkit-transform: translate3d(0, -20%, 0);
            transform: translate3d(0, -20%, 0);
            visibility: visible;
            opacity: 0;
        }

        to {
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
            opacity: 1;
        }
    }

    .open {
        -webkit-animation-name: open;
        animation-name: open;
        -webkit-animation-duration: 1s;
        animation-duration: 1s;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
    }
    .item-menu a{
        transition: all 0.4s ease-in-out 0s;
        color: #fff;
        font-size: 12px;
    }
    .item-menu li{
        padding-bottom: 10px;
    }
    .item-menu li:last-child{
        padding-bottom: 0;
    }
    .foot-address{
        margin: 20px 0;
    }
    .foot-address p{
        line-height: 28px;
        margin-bottom: 0;
        color: #fff;
        opacity: .7;
    }
    .home #footer{
        margin-top: 0;
    }
    @media (max-width: 490px){
        .wrap-col-footer, #newsletter{
            margin-bottom: 40px;
        }
        .wrap-footAddress .foot-img-logo:last-child{
            margin-top: 20px;
        }
        .footer-bottom .text-center p:last-child{
            font-size: 11px;
        }
        .footer-bottom .text-center a{
            padding: 0 5px;
        }
    }
</style>
